export default "data:text/markdown;base64,IyA0MDQgLSBQYWdlIG5vdCBmb3VuZAo="